import Canvas from "./scene/canvas/Canvas";
import {
    useWallReducer, WallActions,
    WallContext,
    WallDispatchContext
} from "./contexts/WallContext";
import {backend} from "./model/Backend";

import {useEffect, useState} from "react";
import * as TWEEN from "@tweenjs/tween.js"
import SidePanel from "./side_panel/SidePanel";
import {UserDispatchContext, UserContext, useUserReducer, UserActions} from "./contexts/UserContext";
import {
    ProposalContext,
    ProposalDispatchContext,
    buildStoreProposalChangeFunction
} from "./contexts/ProposalContext";
import {SpecialStates} from "./common/Utils";
import {CanvasStateContext, SetCanvasStateContext} from "./contexts/CanvasContext";
import GlobalInfoOverlay from "./GlobalInfoOverlay";
import NotificationBox from "./NotificationBox";
import {UiContext, UiDispatchContext, useUiReducer} from "./contexts/UiContext";

if (!backend.valid) {
    console.log("Connection string is invalid.")
}
// This is declared globally because we really don't want to load the wall twice under any circumstances.
let wallPromise = null;

function animate() {
    requestAnimationFrame(animate);
    TWEEN.update();
}

animate();

function App() {
    const [wall, wallDispatch] = useWallReducer();
    const [wallProgress, setWallProgress] = useState(0.0);
    // TODO: make the error graphics more customized (user error (e.g. 404 no wall with given ID) vs our error vs offline)
    const [wallError, setWallError] = useState(null);

    const [proposal, setProposal] = useState(SpecialStates.ToBeLoaded);
    const [canvasState, setCanvasState] = useState(null);
    const [user, userDispatch] = useUserReducer();
    const [ui, uiDispatch] = useUiReducer();

    useEffect(() => {
        if (!backend.valid) {
            setWallError("This URL is not valid, please make sure you typed it correctly.")
            return;
        }
        if (wallPromise === null) {
            function onProgress(progress) {
                setWallProgress(progress);
            }

            wallPromise = backend.loadWall(onProgress);
        }
        wallPromise
            .then(wallResult => wallDispatch({type: WallActions.OnLoaded, wall: wallResult}))
            .catch(e => {
                console.error(e);
                setWallError("An error occurred, please check the URL and your internet connection. If the problem persists, please contact us.");
            });
    }, []);
    useEffect(() => {
        if (user.value === null) {
            userDispatch({
                type: UserActions.TryRestoreLogin,
            });
        }
    }, []);
    if (wallError !== null) {
        // noinspection JSXUnresolvedComponent
        return (
            <GlobalInfoOverlay>
                <GlobalInfoOverlay.ErrorInfo error={wallError}/>
            </GlobalInfoOverlay>
        );
    }
    if (wall === null) {
        // noinspection JSXUnresolvedComponent
        return (
            <GlobalInfoOverlay>
                <GlobalInfoOverlay.ProgressInfo progress={wallProgress}/>
            </GlobalInfoOverlay>
        );
    }
    return (
        <WallContext.Provider value={wall}>
            <WallDispatchContext.Provider value={wallDispatch}>
                <UserContext.Provider value={user}>
                    <UserDispatchContext.Provider value={userDispatch}>
                        <ProposalContext.Provider value={proposal}>
                            <ProposalDispatchContext.Provider
                                value={buildStoreProposalChangeFunction(proposal, setProposal)}>
                                <CanvasStateContext.Provider value={canvasState}>
                                    <SetCanvasStateContext.Provider value={setCanvasState}>
                                        <UiContext.Provider value={ui}>
                                            <UiDispatchContext.Provider value={uiDispatch}>
                                                <Canvas/>
                                                <NotificationBox/>
                                                <SidePanel/>
                                            </UiDispatchContext.Provider>
                                        </UiContext.Provider>
                                    </SetCanvasStateContext.Provider>
                                </CanvasStateContext.Provider>
                            </ProposalDispatchContext.Provider>
                        </ProposalContext.Provider>
                    </UserDispatchContext.Provider>
                </UserContext.Provider>
            </WallDispatchContext.Provider>
        </WallContext.Provider>
    );
}

export default App;
